export default __webpack_public_path__ + "static/media/noBackground.61a5344d.png";